import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {
  ColDef,
  Column, ColumnApi,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent
} from "ag-grid-community";
import {debounceTime, distinctUntilChanged, map, Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {ModalConfig} from "../../../common/modal/modal.config";
import {ModalComponent} from "../../../common/modal/modal.component";
import {MerchantFilter, MerchantService} from "./view-hierarchy.service";
import {NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {SidebarComponent} from "../../layout/sidebar/sidebar.component";
import {SideNavService} from "../../layout/sidebar/side-name.service";
import {StorageService} from "../../../_services/storage.service";
import {Location} from "@angular/common";
import {AlertService} from "../../../_services/alert.service";
import {MenusService} from "../../../_services/menu.service";
import {NgSelectComponent} from "@ng-select/ng-select";
import {FormControl, NgModel, Validators} from "@angular/forms";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../customers/customer-service';
import { UserService } from 'src/app/_services/user.service';
import Swal from 'sweetalert2';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import {HierarchyStateService} from "../link-merchant/create-hierarchy/hierarchy-state.service";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'
const MERCHANT_STATUS = [
  {
    "FieldValue": "approved",
    "FieldText": "Approved"
  },
  {
    "FieldValue": "rejected",
    "FieldText": "Rejected"
  },
  {
    "FieldValue": "suspended",
    "FieldText": "Suspended"
  },
  {
    "FieldValue": "hold",
    "FieldText": "Hold"
  },
  {
    "FieldValue": "active",
    "FieldText": "Active"
  }
];

const CURRENT_TRACK_OPTIONS = [
  { value: "OPERATIONS_L2", label: "Operations L2" },
  { value: "COMPLIANCE_L1", label: "Compliance L1" },
  { value: "COMPLIANCE_L2", label: "Compliance L2" },
  { value: "WAITING_FOR_FINAL_OPS_L2_APPROVAL", label: "Waiting for final Ops L2 Approval" },
  { value: "FULLY_APPROVED", label: "Fully Approved" }
];
 
const LINKED_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "PENDING", label: "Pending" }
];
 
const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

// const API_URL = 'http://localhost:8000'
export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}

export class DetailCellRenderer implements ICellRendererComp {
  eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = '<h1 style="padding: 20px;">My Custom Detail</h1>';
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}

const dateFormatter = (param: any) => {
  const date = param.data.created_on;
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString();
}

const statusFormatter = (param: any) => {
  const sta = param.data.status;
  // @ts-ignore
  const staObj = MERCHANT_STATUS.find((d) => d.FieldValue == sta);
  return staObj?.FieldText || 'Pending';
}

@Component({
  selector: 'app-view-hierarchy',
  templateUrl: './view-hierarchy.component.html',
  styleUrls: ['./view-hierarchy.component.scss']
  })
  export class ViewHierarchyComponent implements OnInit {
  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();

  // @Output() isEdit: EventEmitter<any> = new EventEmitter<any>();
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchEmailId: string ;
  public searchTLN: string ;
  public searchMobile: string ;
  public searchMid: string ;
  public searchCaseId: string;
  public searchCurrentTrack: string;
  public searchLinkedStatus: string;
  public resellerPartnerId:string;
  public Status:string;
  public searchFromDate: NgbDateStruct | null;
  public searchToDate: NgbDateStruct | null;
  public selectedMerchant: string;
  user_type:'NULL';
  merchantStatus: any;
  currentTrackOptions = CURRENT_TRACK_OPTIONS;
  linkedStatusOptions = LINKED_STATUS_OPTIONS;
  public detailCellRenderer = new DetailCellRenderer;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 190,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  dynamicDate:any =this.getToday();
  public rowData!: IMerchantData[];
  tablecolumn: any;
  currentPage: number = 1;
  globalSearch: string = '';
  collectionSize: number = 0;
  collectiondata: number=0
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  modalConfigReport: ModalConfig;
  Merchantdata: any;
  modalConfigBlocked: ModalConfig;
  image : any;
  mindatadis: boolean = true;
  loading: boolean = false;
  public menuItems: any;
  public permissions: any = '';
  currentDate:any=new Date();
  tableInfo: any;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  pageNumber : number;


  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filSearchCaseId') private filSearchCaseId: ElementRef;
  @ViewChild('filSearchCurrentTrack') private filSearchCurrentTrack: ElementRef;
  @ViewChild('filSearchLinkedStatus') private filSearchLinkedStatus: ElementRef;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;



  public columnDefs: ColDef[] = [
    {field: 'masterMerchantId',  headerName: 'Merchant ID',lockVisible:true, resizable: true, cellRenderer: 'agGroupCellRenderer'},
    {field: 'masterMerchantName' ,headerName: 'Merchant Name',lockVisible:true,},
    {field: 'caseId' ,headerName: 'Case Id',lockVisible:true,},
    {field: 'currentTrack' ,headerName: 'Current Track',lockVisible:true,},
    {field: 'linkedStatus',headerName: 'Linked Status',lockVisible:true,},
    {field: 'linkingInitiatedOn' ,headerName: 'Linking Initiated On',lockVisible:true,},
    {field: 'linkingInitiatedBy' ,headerName: 'Linking Initiated By',lockVisible:true,},
    {field: 'linkingApprovedOn' ,headerName: 'Linking Approved On',lockVisible:true,},
    {field: 'linkingApprovedBy' ,headerName: 'Linking Approved By',lockVisible:true,},

    {
      field: 'screening',headerName: 'view hierarchy ',lockVisible:true, width: 30, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId
            console.log("Clicked View Report :"+JSON.stringify(param.data.mobileNumber));
            this.customerService.getCustomerPdfById(this.tableInfo)
              .subscribe((data:any) => {
                console.log(data);
                var reader = new FileReader();
                reader.readAsDataURL(data.body); 
                new Promise((resolve, reject) =>{ 
                  reader.onloadend = function() {
                    resolve(reader.result);                
                  }
                }).then(data=>{
                  this.image = data;
                  this.ScreeningReportEvent.emit(data);
                  // this.downloadPdf(data);
                  return this.modalReportComponent.open();  
                });
                })
          },
          buttonIconClass: 'icon-eye',
          buttonVisible: true
        },

      ]
    },

  ];
  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  private gridApi!: GridApi;
  private filterObj: any = {};
  @ViewChild('modalEdit') private modalEditComponent: ModalComponent
  @ViewChild('modalAdd') private modalAddComponent: ModalComponent
  @ViewChild('modalMerchant') private modalMerchantComponent: ModalComponent
  @ViewChild('modalMerchantBank') private modalMerchantBankComponent: ModalComponent
  private innerWidth: number;
  private _event: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  Resultdata: any;
  private gridColumnApi!: ColumnApi;
  totalRecords: any;

  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService,
     private ngbCalender: NgbCalendar,private ngbDateParserFormatter: NgbDateParserFormatter,private customerService: CustomerService,private userService : UserService, private piiGridService: PiiGridService, private hierarchyStateService: HierarchyStateService) {

    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();  
    // this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.rowData.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1)).map(v => v.name).slice(0, 10))
    );
  maxSize: number;
  ellipses: boolean= true;

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    console.log(path)
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Merchant Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Entity Screening Report",
      modalSize: 'xl',
      css : "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    // this.merchantService.getResellerList().subscribe((data) => this.resellerListOptions = data)
    // this.merchantStatusDropdown()
    // this.MerchnatList()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log(this.innerWidth, "------->");
    this._event = event;
    this.innerWidth = window.innerWidth;
    this.setPageSize();
  }

  onSortChange(event : any){    
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }

  changeDate(){
    this.currentDate = this.searchFromDate
    if(this.searchFromDate) {
      this.minDate = this.searchFromDate;
    }
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate()
  {
    this.currentDate = this.searchToDate;
    if(this.searchToDate) {
      this.maxDateFrom=this.searchToDate;
    }
  }


  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }

  posRequest(data: any) {
  console.log(data);
  Swal.fire({
    title: 'Are you sure you want to request for POS this merchant ' + data?.fullName + '?',
    showCancelButton: true,
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      //Call API for POS
      console.log(data.userId)
      this.merchantService.sendPOSRequest(data.userId).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('Your POS Request sent successfully', '', 'success');

          //Refresh List of Merchant
          const filter: MerchantFilter = {}
          console.log(this.ngbDateParserFormatter.format(this.searchFromDate))
          if(this.searchMerName == null || this.searchMerName == ""){
            this.searchMerName = "";
          }
          if(this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
            filter.startDate = "";
          }else{
            filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
          }
          if(this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
            filter.endDate = "";
          }else{
            filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
          }
        
          this.merchantService.getMerchantList(this.searchMid,this.searchMerName,this.searchEmailId,this.Status,this.resellerPartnerId,this.searchTLN,filter,this.pageSize,this.pageNumber,this.searchCaseId,this.searchCurrentTrack,this.searchLinkedStatus)
            .subscribe((data) => {
              this.rowData = data.content.map((row: any) => ({
                ...row,
                reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
              }));
              this.collectiondata = data.content
              this.collectionSize=data.totalElements
              this.totalRecords =  data.content
            });
          return;
        }
        Swal.fire(response.response.message, '', 'error');
      })
    }
  });
}


  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }

  updateSelectedColumn(event : any) {
    if (event.target.checked) {

      if (this.columnDefsCopy[parseInt(event.target.value)].field == "actions" && !this.permissions.includes('Edit')) {
        console.log("Action Disabled");
        this.gridApi.setColumnDefs(this.tableSelectedColumn)
        this.gridApi.setDefaultColDef(this.defaultColDef);
        return;
      }

      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.searchCaseId = '';
      this.searchCurrentTrack = '';
      this.searchLinkedStatus = '';
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  onSearchBtnClick($event: Event) {
    const filter: MerchantFilter = {}
    debugger
    console.log(this.ngbDateParserFormatter.format(this.searchFromDate))
    if(this.searchMerName == null || this.searchMerName == ""){
      this.searchMerName = "";
    }
    if(!this.searchFromDate || this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
      filter.startDate = "";

    }else{
      filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
    if(!this.searchToDate || this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
      filter.endDate = "";

    }else{
      filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    if(filter.startDate != "" && filter.endDate == ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date To");
    return;
    }
    if(filter.startDate == "" && filter.endDate != ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date From");
    return;
    }
    this.pageNumber = 0;
    return this.merchantService.getMerchantList(this.searchMid,this.searchMerName,this.searchEmailId,this.Status,this.resellerPartnerId,this.searchTLN,filter,this.pageSize,this.pageNumber,this.searchCaseId,this.searchCurrentTrack,this.searchLinkedStatus)
      .subscribe((data) => {

        this.rowData = data.content.map((row: any) => ({
          ...row,
          reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
        }));
        this.collectiondata = data.content
        this.collectionSize=data.totalElements
        this.totalRecords =  data.content
        if(data.content.length <=0){
          this.alertService.errorAlertWithMessage("No records present");
          return }
      });
  }



  closeModalAdd($event: any) {
    if (!$event.showModal) {
      this.modalAddComponent.close();
      this.refreshGrid();
    }

  }

  refreshGrid() {
    const filter: MerchantFilter = {}
    this.gridApi.applyTransaction({remove: this.rowData});
    return this.merchantService.getMerchantList("","","",this.Status,"","",filter,this.pageSize,this.pageNumber,"","","")
      .subscribe((data) => {
        this.rowData = data.content.map((row: any) => ({
          ...row,
          reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
        }));
        this.collectiondata = data.content
        this.collectionSize=data.totalElements
        this.totalRecords =  data.content
  });
  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    const filter: MerchantFilter = {}
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.userService.getUserProfileNew().subscribe((data) => {
      if(data.ROLEID == 273){
        this.gridColumnApi.setColumnsVisible(["screening"], false);
      }
    });
    if (!this.permissions.includes('Edit')) {
      this.gridColumnApi.setColumnsVisible(["actions"], false);
    }
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);

    return this.merchantService.getMerchantList("","","","","","",filter,10,0,"","","")
      .subscribe((data) => {
        console.log(data);
        this.rowData = data.content.map((row: any) => ({
          ...row,
          reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
        }));
       
        console.log(" this.rowData= merchant masterlist==="+ JSON.stringify(this.rowData))
        this.collectiondata = data.content
        this.collectionSize=data.totalElements
        this.totalRecords =  data.content
      });
  }

  onBtnC(e: Event) {
    e.preventDefault();
    // @ts-ignore
    return this.apiHttpService
      .get(
        `${API_URL}/get-merchant`
      )
      // @ts-ignore
      .subscribe((data) => (this.gridApi.applyTransaction({add: data})));
  }

  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Merchant_Master' + "_" + referenceId;
    const filter: MerchantFilter = {}
   
    if(this.searchMerName == null || this.searchMerName == ""){
      this.searchMerName = "";
    }
    if(this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
      filter.startDate = "";

    }else{
      filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
    if(this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
      filter.endDate = "";

    }else{
      filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    if(filter.startDate != "" && filter.endDate == ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date To");
    return;
    }
    if(filter.startDate == "" && filter.endDate != ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date From");
    return;
    }
    return this.merchantService.getMerchantList(this.searchMid,this.searchMerName,this.searchEmailId,this.Status,this.resellerPartnerId,this.searchTLN,filter,this.pageSize,this.pageNumber,this.searchCaseId,this.searchCurrentTrack,this.searchLinkedStatus)
      .subscribe((data) => {
        if(this.rowData.length <=0){
          this.alertService.errorAlertWithMessage("No records present");
          return }

        const expData: any[] = [];
        (data.content || data || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions")){
              if (col?.field) tempRec[col?.field] = curr[col?.field]
          }
        })
          expData.push(tempRec);
        })
        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions" || col?.field=="screening"))
      {
       tempRec[index] = col
       index++;
    }

  })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  searchQuickFilter($event?: NgbTypeaheadSelectItemEvent) {
    this.gridApi.setQuickFilter($event?.item);
  }

  onGlobalSearchChange($event: any) {
    if ($event == '' || $event == null) {
      this.gridApi.setQuickFilter($event);
    }
  }

  async onAddNew($event: any) {
    // this.sidebarComponent.sidebarToggler.nativeElement.click();
    await this.sideNavService.toggelEvent$.emit($event)
    // await this.sideNavService.toggle($event);
    await this.router.navigate(['/create-hierarchy/master-merchant-selection'])
    // return await this.modalAddComponent.open();
  }
 
  async MerchantNew() {
    return await this.modalMerchantComponent.open();
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: MerchantFilter = {}
    if(this.searchMerName == null || this.searchMerName == ""){
      this.searchMerName = "";
    }
    if(this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
      filter.startDate = "";

    }else{
      filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
    if(this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
      filter.endDate = "";

    }else{
      filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    if(filter.startDate != "" && filter.endDate == ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date To");
    return;
    }
    if(filter.startDate == "" && filter.endDate != ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date From");
    return;
    }
    this.pageNumber = (param-1);
    this.merchantService.getMerchantList(this.searchMid,this.searchMerName,this.searchEmailId,this.Status,this.resellerPartnerId,this.searchTLN,filter,this.pageSize,this.pageNumber,this.searchCaseId,this.searchCurrentTrack,this.searchLinkedStatus)
      .subscribe((data) => {
        this.rowData = data.content.map((row: any) => ({
          ...row,
          reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
        }));
        this.collectiondata = data.content
        this.collectionSize=data.totalElements
        this.totalRecords =  data.content

          this.gridApi.applyTransaction({add: this.rowData});
          this.collectionSize=data.totalElements

          
        }
      );
  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }


  async onRowDoubleClicked(param: RowClickedEvent | any) {  
   // Open create hierarchy in view mode with caseId
   const caseId = param?.data?.caseId;
   if (caseId) {
     // Set view mode in service instead of URL
     this.hierarchyStateService.setViewMode(true);
     return await this.router.navigate(['/create-hierarchy/master-merchant-selection'], {
       queryParams: {
         caseId: caseId
       }
     });
   }
    return false
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: MerchantFilter = {}

    if(this.searchMerName == null || this.searchMerName == ""){
      this.searchMerName = "";
    }
    if(this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
      filter.startDate = "";

    }else{
      filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
    if(this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
      filter.endDate = "";

    }else{
      filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    if(filter.startDate != "" && filter.endDate == ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date To");
    return;
    }
    if(filter.startDate == "" && filter.endDate != ""){
    this.alertService.toastWarringMessageAlertWithMessage("Please select Date From");
    return;
    }
    this.merchantService.getMerchantList(this.searchMid,this.searchMerName,this.searchEmailId,this.Status,this.resellerPartnerId,this.searchTLN,filter,this.pageSize,this.pageNumber,this.searchCaseId,this.searchCurrentTrack,this.searchLinkedStatus)
      .subscribe((data) => {
        this.rowData = data.content.map((row: any) => ({
          ...row,
          reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
        }));
        this.collectiondata = data.content
        this.collectionSize=data.totalElements
        this.totalRecords =  data.content
         this.gridApi.applyTransaction({add: this.rowData})});

  }

  MerchnatList() {
    let reqData = {
      "name": ""
    }
    console.log("request body", reqData)
    this.merchantService.getMerchantBYName(reqData).subscribe((res:any) => {
        this.Resultdata = res
        console.log("merchant mid",res)
      });
  }


  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  merchantStatusDropdown() {
  // return this.merchantService.getMerchantStatus()
      // .post(
      //   `${API_URL}/GetDropdown`, postdata
      // )
      // .subscribe((res) => (this.merchantStatusdata = res,console.log("res",this.merchantStatusdata)));

  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  allowAlfanumeric($event: Event): void {
    // if(this.searchMID.length>10)
    // {
    //   return
    // }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    // this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  resetFilter(){
    this.searchFromDate = null;
    this.searchToDate = null;
    this.searchMerName = "";
    this.searchEmailId = "";
    this.searchTLN = "";
    this.searchMid = "";
    this.searchMobile = "";
    this.searchCaseId = "";
    this.searchCurrentTrack = "";
    this.searchLinkedStatus = "";
    this.filSearchMID.handleClearClick();
    this.filResellerPartnerId.handleClearClick();
    this.filSearchMerName.handleClearClick();
    this.filStatus.handleClearClick();

    this.pageNumber = 0;
    this.currentPage = 1;
    this.refreshGrid();

  }

  toUppercase(event: Event) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
  
    const upper = input.value.toUpperCase();
    input.value = upper;

    this.searchTLN = upper;
  
    input.setSelectionRange(start, end);
  }
  
}
